module.exports = __webpack_public_path__ + "img/30.828c2627.png";